import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'BaseServices/main-service';
import { EquipmentDetailDTO } from 'projects/EquipmentRegistration/src/equipment-registration-base/dataTypes';

@Component({
  selector: 'app-equipment-control-status-tab',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './equipment-control-status-tab.component.html',
  styleUrls: ['./equipment-control-status-tab.component.css'],
})
export class EquipmentControlStatusTabComponent implements OnInit {
  equipmentId = 0;

  equipment = {
    lastServiceBy: '',
    serviceFrequency: '',
    lastServiceText: '',
    nextControlText: '',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private mainService: MainService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.parent?.paramMap.subscribe((params) => {
      this.equipmentId = Number(params.get('id') ?? 0);

      if (!this.equipmentId) return;

      this.loadEquipment(this.equipmentId);
    });
  }

  private loadEquipment(id: number): void {
    this.mainService.get<EquipmentDetailDTO>('Equipment', id).subscribe({
      next: (equipment) => {
        this.populateForm(equipment);
      },
      error: (err) => {
        console.error('Could not load equipment', err);
      },
    });
  }

  private formatDate(value: unknown): string {
    if (!value) return '';

    const date = new Date(value as any);
    if (!Number.isFinite(date.getTime())) return '';

    return date.toLocaleDateString('da-DK');
  }

  private parseFrequencyMonths(frequencyText: unknown): number {
    const text = String(frequencyText ?? '').trim();
    if (!text) return 0;

    const match = text.match(/\d+/);
    return match ? Number(match[0]) : 0;
  }

  private addMonths(date: Date, months: number): Date {
    const nextDate = new Date(date);
    const day = nextDate.getDate();

    nextDate.setMonth(nextDate.getMonth() + months);

    if (nextDate.getDate() < day) {
      nextDate.setDate(0);
    }

    return nextDate;
  }

  private calcNextControlDate(lastServiceDate: unknown, frequencyText: unknown): string {
    if (!lastServiceDate) return '';

    const date = new Date(lastServiceDate as any);
    if (!Number.isFinite(date.getTime())) return '';

    const months = this.parseFrequencyMonths(frequencyText);
    if (months <= 0) return '';

    return this.addMonths(date, months).toLocaleDateString('da-DK');
  }

  private populateForm(equipment: EquipmentDetailDTO): void {
    const eq: any = equipment;

    const lastServiceDate =
      eq.LastServiceDate ??
      eq.lastServiceDate ??
      eq.ServiceDate ??
      eq.serviceDate ??
      null;

    const serviceFrequency =
      eq.ServiceFrequencyMonths ??
      eq.serviceFrequencyMonths ??
      '';

    this.equipment = {
      lastServiceBy: String(
        eq.LastServicePerformedBy ??
        eq.lastServicePerformedBy ??
        eq.ServiceBy ??
        eq.serviceBy ??
        ''
      ),
      serviceFrequency: String(serviceFrequency),
      lastServiceText: this.formatDate(lastServiceDate),
      nextControlText: this.calcNextControlDate(lastServiceDate, serviceFrequency),
    };
  }
}
